/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { TaxId } from './TaxId';
import {
    TaxIdFromJSON,
    TaxIdFromJSONTyped,
    TaxIdToJSON,
    TaxIdToJSONTyped,
} from './TaxId';
import type { SubscriptionSafe } from './SubscriptionSafe';
import {
    SubscriptionSafeFromJSON,
    SubscriptionSafeFromJSONTyped,
    SubscriptionSafeToJSON,
    SubscriptionSafeToJSONTyped,
} from './SubscriptionSafe';

/**
 * 
 * @export
 * @interface StripePaymentDetails
 */
export interface StripePaymentDetails {
    /**
     * Company name as registered in Stripe
     * @type {string}
     * @memberof StripePaymentDetails
     */
    companyName: string;
    /**
     * Billing address on file in Stripe
     * @type {Address}
     * @memberof StripePaymentDetails
     */
    billingAddress: Address;
    /**
     * List of tax IDs registered in Stripe
     * @type {Array<TaxId>}
     * @memberof StripePaymentDetails
     */
    taxIds: Array<TaxId>;
    /**
     * One of {@code exempt}, {@code none}, or {@code reverse}.
     * @type {string}
     * @memberof StripePaymentDetails
     */
    taxStatus: string;
    /**
     * List of active Stripe subscriptions for the user
     * @type {Array<SubscriptionSafe>}
     * @memberof StripePaymentDetails
     */
    subscriptions: Array<SubscriptionSafe>;
}

/**
 * Check if a given object implements the StripePaymentDetails interface.
 */
export function instanceOfStripePaymentDetails(value: object): value is StripePaymentDetails {
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('billingAddress' in value) || value['billingAddress'] === undefined) return false;
    if (!('taxIds' in value) || value['taxIds'] === undefined) return false;
    if (!('taxStatus' in value) || value['taxStatus'] === undefined) return false;
    if (!('subscriptions' in value) || value['subscriptions'] === undefined) return false;
    return true;
}

export function StripePaymentDetailsFromJSON(json: any): StripePaymentDetails {
    return StripePaymentDetailsFromJSONTyped(json, false);
}

export function StripePaymentDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripePaymentDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'companyName': json['companyName'],
        'billingAddress': AddressFromJSON(json['billingAddress']),
        'taxIds': ((json['taxIds'] as Array<any>).map(TaxIdFromJSON)),
        'taxStatus': json['taxStatus'],
        'subscriptions': ((json['subscriptions'] as Array<any>).map(SubscriptionSafeFromJSON)),
    };
}

export function StripePaymentDetailsToJSON(json: any): StripePaymentDetails {
    return StripePaymentDetailsToJSONTyped(json, false);
}

export function StripePaymentDetailsToJSONTyped(value?: StripePaymentDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyName': value['companyName'],
        'billingAddress': AddressToJSON(value['billingAddress']),
        'taxIds': ((value['taxIds'] as Array<any>).map(TaxIdToJSON)),
        'taxStatus': value['taxStatus'],
        'subscriptions': ((value['subscriptions'] as Array<any>).map(SubscriptionSafeToJSON)),
    };
}

